import React from 'react';
import { connect } from 'react-redux';

// Components
import { Link } from 'react-router-dom';
import { Layout, Card, Breadcrumb, Row, Icon } from 'antd';
import Monitoring from './Monitoring';
import { isRoleAdministrator } from '../../data/auth/selectors';

// Others
import { strings } from '../../localization';
import { ROUTE_NAMES } from '../../utils';

const Dashboard = ({isAdmin}) => (
    <React.Fragment>
        <Layout key="admin-users-content">
            <Layout.Content style={{ padding: '10px' }}>
                <Card style={{ marginBottom: '30px' }}>
                    <h2 data-testid="headline">{strings.dashboardRoute}</h2>
                    <Breadcrumb separator=">">
                        <Breadcrumb.Item>{strings.appName}</Breadcrumb.Item>
                        <Breadcrumb.Item>
                            <Link to={ROUTE_NAMES.DASHBOARD}>
                                <Icon type="deployment-unit" />
                                &nbsp;
                                {strings.dashboardRoute}
                            </Link>
                        </Breadcrumb.Item>
                    </Breadcrumb>
                </Card>
                <Row>
                    <Monitoring />
                </Row>
            </Layout.Content>
        </Layout>
    </React.Fragment>
);

export default connect(
    state => ({
        isAdmin: isRoleAdministrator(state)
    }),
    {}
)(Dashboard);
